import React from "react";
import Seo from "../Seo/Seo";
import SiteFooter from "../SiteFooter/SiteFooter";
import Wrapper from "../Wrapper/Wrapper";
import styles from "./Layout.module.css";

type Props = {
  additionalContent?: React.ReactNode;
  children?: React.ReactNode;
  header?: React.ReactNode;
  hero?: React.ReactNode;
  sidebar?: React.ReactNode;
  metaDescription?: string;
  metaTitle?: string;
  metaUrl?: string;
};

const Layout = ({
  additionalContent,
  children,
  header,
  hero,
  metaDescription,
  metaTitle,
  metaUrl,
  sidebar,
}: Props) => (
  <article className={styles.root}>
    <Seo metaDescription={metaDescription} metaTitle={metaTitle} metaUrl={metaUrl} />
    {header}
    {hero}
    <main className={styles.content}>
      <Wrapper>
        {sidebar ? (
          <div className={styles.flex}>
            {sidebar}
            <div className={styles.children}>{children}</div>
          </div>
        ) : (
          <>{children}</>
        )}
      </Wrapper>
    </main>
    {additionalContent}
    <SiteFooter />
  </article>
);

export default Layout;
